import styles from "../landing-page-four.module.css";
import { ProjectPreview } from "components/common/project-preview";
import { useState, useEffect } from "react";
import { useCollectionStore } from "entity-store/collections-store/use-collection-store";
import { useTemplateStore } from "entity-store/template-store/use-template-store";
import { ProjectTemplate } from "PosterEditor/model/project-template";

interface PresetsSectionProps {
  onClickTemplate: (template: ProjectTemplate) => void;
}

export const PresetsSection = (props: PresetsSectionProps) => {
  const { loadCollectionByID } = useCollectionStore();
  const { loadTemplatesByIDs } = useTemplateStore();
  const [templates, setTemplates] = useState<ProjectTemplate[]>([]);

  useEffect(() => {
    loadCollectionByID("8725e8ae-df7a-45bc-b789-a0741fa65bfc").then(
      (collection) => {
        if (collection) {
          let ids = collection?.templateIDs;
          loadTemplatesByIDs(ids).then(setTemplates);
        }
      }
    );
  }, []);

  return (
    <div className={styles.sectionContainer}>
      <h2 className={styles.sectionTitle}>Featured Design Templates</h2>
      <div className={styles.presetsContainer}>
        {templates.map((template) => (
          <div className={styles.presetSquare} key={template.id}>
            <button
              className={styles.templateWrapper}
              onClick={() => props.onClickTemplate(template)}
            >
              <ProjectPreview
                template={template}
                className={styles.templatePreview}
                allowHoverEffect={true}
              />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
